import b1 from '../boards/board1.json';
import b2 from '../boards/board2.json';
import b3 from '../boards/board3.json';
import b4 from '../boards/board4.json';
import b5 from '../boards/board5.json';
import b6 from '../boards/board6.json';
import b7 from '../boards/board7.json';
import b8 from '../boards/board8.json';
import b9 from '../boards/board9.json';
import b10 from '../boards/board10.json';
import g1 from '../boards/gauntlet1.json';
import g2 from '../boards/gauntlet2.json';
import g3 from '../boards/gauntlet3.json';
import { parseBoard, type Board, type BoardData } from './sim/index.ts';

/** Shaft 1 (MVP v0.2 §3.1): slots 1–2 teach, 3–5 normal, 6 Hard, 7–8 normal, 9 Super Hard, 10 release valve. */
export const BOARD_DATA: BoardData[] = [b1, b2, b3, b4, b5, b6, b7, b8, b9, b10] as BoardData[];
export const BOARDS: Board[] = BOARD_DATA.map(parseBoard);
/** Gauntlet rotation: goal-less boards flagged `gauntlet: true` (the three legacy layouts for now). */
export const GAUNTLET_DATA: BoardData[] = [g1, g2, g3] as BoardData[];
export const GAUNTLET_BOARDS: Board[] = GAUNTLET_DATA.map(parseBoard);
export const ALL_BOARDS: Board[] = [...BOARDS, ...GAUNTLET_BOARDS];
export const BOARDS_BY_ID = new Map(ALL_BOARDS.map((b) => [b.id, b]));
